import { useId, type ReactElement, type ReactNode } from 'react';
import { Label } from './Label';

/**
 * FormField composes label + input + (hint or error). Pass the input as a
 * function so we can wire the generated id without the caller plumbing it
 * by hand:
 *
 *   <FormField label="Email">
 *     {(id) => <Input id={id} type="email" />}
 *   </FormField>
 */
export function FormField({
  label,
  hint,
  error,
  children,
}: {
  label: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  children: (id: string) => ReactElement;
}) {
  const id = useId();
  return (
    <div className="ds-form-field">
      <Label htmlFor={id}>{label}</Label>
      {children(id)}
      {error ? (
        <span className="ds-form-field__error">{error}</span>
      ) : hint ? (
        <span className="ds-form-field__hint">{hint}</span>
      ) : null}
    </div>
  );
}
